import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

/** 反馈工单入库 / 接口约定：东八区墙钟时间（无时区后缀） */
export const FEEDBACK_BUSINESS_TZ = 'Asia/Shanghai'

const PARSE_FORMAT = 'YYYY-MM-DD HH:mm:ss'

function parseBusinessDateTime(value: string) {
  const normalized = value.trim().replace('T', ' ').replace(/\.\d+$/, '').slice(0, 19)
  return dayjs.tz(normalized, PARSE_FORMAT, FEEDBACK_BUSINESS_TZ)
}

/**
 * 用户侧展示：把东八区时间换算成当前浏览器本地时区。
 * 例：库里 21:00（北京）→ 巴西用户显示 10:00
 */
export function formatFeedbackLocalDateTime(
  value?: string | null,
  pattern = 'YYYY-MM-DD HH:mm:ss'
): string {
  if (!value) return '-'
  const parsed = parseBusinessDateTime(value)
  if (!parsed.isValid()) return value
  return parsed.tz(dayjs.tz.guess()).format(pattern)
}

/**
 * 客服侧展示：保持东八区，不跟用户浏览器走。
 */
export function formatFeedbackBusinessDateTime(
  value?: string | null,
  pattern = 'YYYY-MM-DD HH:mm:ss'
): string {
  if (!value) return '-'
  const parsed = parseBusinessDateTime(value)
  if (!parsed.isValid()) return value
  return parsed.format(pattern)
}
